
export default {
  name: "comingSoon",
};
